// extracted by mini-css-extract-plugin
export default {"container":"BpsAdminLayout_container__8zqLw","contentContainer":"BpsAdminLayout_contentContainer__wCqg5","content":"BpsAdminLayout_content__Cz7t0"};